'use client';

import { withAuth } from '@/components/auth/with-auth';
import MobileTopBar from '@/components/chat/top-bars/mobile-top-bar';
import Providers from '@/components/root/root-layout';
import SidebarsLayout from '@/components/root/sidebars-layout';

import { Intercom } from './intercom';
import Onboarding from './onboarding';

// css will adjust this layout vis for the onboarding spinner and redirect to prevent a flash
const Layout = ({ children }) => {
  return (
    <Providers>
      <Onboarding />
      <Intercom />
      <MobileTopBar />
      <SidebarsLayout>{children}</SidebarsLayout>
    </Providers>
  );
};

export default withAuth(Layout);
